import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaUserCircle } from 'react-icons/fa';
import { signOut, getCurrentUser } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    checkUser();

    // Listen for auth events (sign in, sign out)
    const hubListener = Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signedIn':
          checkUser();
          break;
        case 'signedOut':
          setUser(null);
          break;
      }
    });

    return () => hubListener();
  }, []);

  async function checkUser() {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      setUser(null);
    }
  }

  const handleSignOut = async () => {
    try {
      await signOut();
      setUser(null);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <NavLink to="/" className="navbar-logo" onClick={() => setIsOpen(false)}>
          QED AI
        </NavLink>
        
        <div className="menu-icon" onClick={toggleMenu}>
          {isOpen ? <span>{React.createElement(FaTimes as any)}</span> : <span>{React.createElement(FaBars as any)}</span>}
        </div>

        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <NavLink to="/" className={({ isActive }) => "nav-links" + (isActive ? " active-link" : "")} onClick={() => setIsOpen(false)}>
              Home
            </NavLink>
          </li>
          {user && (
            <li className="nav-item">
                <NavLink to="/admin" className={({ isActive }) => "nav-links" + (isActive ? " active-link" : "")} onClick={() => setIsOpen(false)}>
                Admin
                </NavLink>
            </li>
          )}
          
          {user ? (
             <li className="nav-item">
                <div className="nav-links" onClick={() => { handleSignOut(); setIsOpen(false); }} style={{cursor: 'pointer'}}>
                   Sign Out
                </div>
              </li>
          ) : (
             <li className="nav-item">
                <NavLink to="/login" className="nav-links" onClick={() => setIsOpen(false)}>
                   Sign In
                </NavLink>
             </li>
          )}
          
          <li className="nav-item">
              <NavLink to={user ? "/admin" : "/login"} className="nav-links-mobile" onClick={() => setIsOpen(false)}>
                  <span>{React.createElement(FaUserCircle as any, { size: 24 })}</span>
              </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;

